module.exports = __webpack_public_path__ + "img/bg.37859ec5.png";